<template>
  <Modal v-model="choiceBillModal" width="1200" footer-hide>
    <p slot="header" class="text-center">添加合同账单</p>
    <Row :gutter="8" class="m-b-5">
      <i-col span="24">
        <Button type="primary" size="small" class="m-r-20" :disabled="selectedIds.length===0" @click="handleBatchSubmit">批量添加至收款单</Button>
      </i-col>
    </Row>
    <Table
      size="small"
      ref="selectionTable"
      :columns="tableColumns"
      :data="tableData"
      :loading="tableLoading"
      @on-selection-change="selectionChange"
      stripe
    ></Table>
    <div class="paging_style">
        <Page size="small" show-total show-elevator :current="query.pageNumber" :page-size="query.pageSize" :total="total" @on-change="handlePageNumberChange"></Page>
    </div>

    <Spin fix size="large" v-if="spinShow">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>提交中...</div>
    </Spin>
  </Modal>
</template>

<script>
import { toMoney } from '@/utils/wnumb_own'
import { pageElectricMeterRecord } from '@/api/invest/electricMeterRecord'
import { addFeeItemToBill } from '@/api/invest/electricMeterBill'

export default {
  data () {
    return {
      choiceBillModal: false,
      spinShow: false,

      billId: null,
      selectedIds: [],
      query: {
        current: 1,
        size: 15,
        meterId: null,
        assetId: null,
        keyWord: null,
        status: 1, // 缴费状态(1:待缴费，2:缴费中,3:已缴费)
        stationId: null,
        contractId: null
      },

      tableLoading: false,
      total: 0,
      tableData: [],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '资源编号', key: 'deviceCode' },
        { title: '电表编号', key: 'meterCode' },
        { title: '最近抄表时间', key: 'readDate' },
        { title: '上期读数/底表读数', key: 'lastValue' },
        { title: '本期读表数', key: 'currentValue' },
        { title: '本期用电量(kwh)', key: 'electricityConsume' },
        { title: '线损', key: 'lineLost' },
        {
          title: '电费单价',
          key: 'unitPrice',
          render: (h, params) => {
            return h('strong', {},
              toMoney(params.row.unitPrice))
          }
        },
        {
          title: '本期电费合价(元)',
          key: 'chargeAmount',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.chargeAmount))
          }
        },
        { title: '计价月份', key: 'chargeMonthStr' }
      ]
    }
  },
  methods: {
    showModal (contractId, billId) {
      this.choiceBillModal = true
      this.billId = billId
      this.query.contractId = contractId
      this.initPageData()
    },
    initPageData () {
      this.tableLoading = true
      // 载入账单信息
      pageElectricMeterRecord(this.query).then(res => {
        const pageData = res.records
        // 需要自动勾选被选中的项
        pageData.forEach(item => {
          item._checked = this.selectedIds.includes(item.meterRecordId)
        })

        this.tableData = pageData
        this.total = res.total
        this.tableLoading = false
      })
    },
    handlePageNumberChange (page) {
      this.query.current = page
      this.initPageData()
    },
    selectionChange (selections) {
      const curSelection = selections.map(x => x.meterRecordId)
      this.tableData.forEach(item => {
        // 当前被勾选
        if (curSelection.includes(item.meterRecordId)) {
          if (!this.selectedIds.includes(item.meterRecordId)) {
            this.selectedIds.push(item.meterRecordId)
          }
        } else {
          // 当前未被勾选， 且存在勾选清单，那么移除
          if (this.selectedIds.includes(item.meterRecordId)) {
            const index = this.selectedIds.findIndex(x => x === item.meterRecordId)
            this.selectedIds.splice(index, 1)
          }
        }
      })
    },
    handleBatchSubmit () {
      const addBean = {
        billId: this.billId,
        meterRecordIdStr: JSON.stringify(this.selectedIds)
      }

      this.spinShow = true
      addFeeItemToBill(addBean).then(res => {
        this.$emit('on-success')
        this.$Notice.success({ desc: '操作成功' })
      }).finally(() => {
        this.spinShow = false
        this.choiceBillModal = false
      })
    }
  }
}
</script>
